import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Lending Library';
}



// WEBPACK FOOTER //
// /home/shalom/sandbox/kidlendinglibrary/kidlendinglibrary/src/app/app.component.ts